// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Button from "../../resources/actions/Button.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as JsxRuntime from "react/jsx-runtime";

function Make(Params) {
  let Form__Elements__Buttons$Make$CancelButton = props => {
    let onPress = props.onPress;
    let __tone = props.tone;
    let tone = __tone !== undefined ? __tone : ({
        NAME: "neutral",
        VAL: {
          quiet: false
        }
      });
    let match = Params.useCancel();
    let onCancel = match[1];
    let handlePress = param => {
      Stdlib_Option.forEach(onPress, fn => fn());
      onCancel();
    };
    return JsxRuntime.jsx(Button.make, {
      label: props.label,
      tone: tone,
      size: props.size,
      disabled: match[0],
      icon: props.icon,
      onPress: handlePress
    });
  };
  let CancelButton = {
    make: Form__Elements__Buttons$Make$CancelButton
  };
  let Form__Elements__Buttons$Make$SubmitButton = props => {
    let onSubmitRequested = props.onSubmitRequested;
    let __derivedDisabled = props.disabled;
    let __tone = props.tone;
    let tone = __tone !== undefined ? __tone : "brand";
    let derivedDisabled = __derivedDisabled !== undefined ? __derivedDisabled : false;
    let match = Params.useSubmit(props.onSubmit);
    let onSubmit = match.onSubmit;
    let pending = match.submission === "Requested";
    let disabled = derivedDisabled || match.disabled && !pending;
    return JsxRuntime.jsx(Button.make, {
      label: props.label,
      variant: "solid",
      tone: tone,
      size: props.size,
      disabled: disabled,
      pending: pending,
      icon: props.icon,
      onPress: () => {
        Stdlib_Option.forEach(onSubmitRequested, onSubmitRequested => onSubmitRequested());
        onSubmit();
      }
    });
  };
  let SubmitButton = {
    make: Form__Elements__Buttons$Make$SubmitButton
  };
  return {
    CancelButton: CancelButton,
    SubmitButton: SubmitButton
  };
}

let Submission;

export {
  Submission,
  Make,
}
/* Button Not a pure module */
